export default "__VITE_ASSET__wgPqNLYO__"